var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footy"},[_c('div',{staticClass:"dF jC",class:_vm.$style.inner},[_c('router-link',{staticClass:"px-4",attrs:{"to":"/privacy"}},[_vm._v("Privacy")]),_c('router-link',{staticClass:"px-4",attrs:{"to":"/terms"}},[_vm._v("Terms")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }